import React from "react";

import RecorderService from "./RecorderService";

class VideoRecorder extends React.Component {
  constructor(props) {
    super(props);
    console.log("VideoRecorder constructor");
    this.state = {
    };
    this.recording_status = props.recording_status;
    this.show_video_stream = props.show_video_stream || false;
    this.recorderSrvc = null;
  }

  componentWillUnmount() {
    console.log("VideoRecorder componentWillUnmount");
    if (this.recorderSrvc) {
      this.recorderSrvc.cleanupThings();
      this.recorderSrvc = null;
    }
    this.props.getMediaStreamCallback(false);
  }
  
  componentDidMount() {
  }
  
  async componentDidUpdate () {
    //console.log("componentDidUpdate",this.recording_status,this.props.recording_status);
    if (this.recording_status !== this.props.recording_status) {
      // for starting/stopping/pausing/unpausing recording
      this.changeRecordingStatus(this.recording_status,this.props.recording_status);
    }
    if (this.show_video_stream !== this.props.show_video_stream) {
      // for turning camera on and off while not recording
      this.show_video_stream = this.props.show_video_stream;
      if (this.props.show_video_stream) {
        this.recorderSrvc = new RecorderService(this.dispatchData);
        this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt));
        let stream = await this.recorderSrvc.getMediaStream();
        this.props.getMediaStreamCallback(stream);
      } else {
        if (this.recorderSrvc) {
          this.recorderSrvc.cleanupThings();
          this.recorderSrvc = null;
        }
        this.props.getMediaStreamCallback(false);
      }
    }
  }
  
  async changeRecordingStatus(prev_recording_status,new_recording_status) {
    console.log("VideoRecorder changeRecordingStatus",prev_recording_status,'->',new_recording_status);
    this.recording_status = new_recording_status;
    
    if (prev_recording_status === null && new_recording_status === 'init_recording') {
      // start recording at first slide
      this.handleStartRecording();
      this.recording_status = 'recording';
    } else if (prev_recording_status === 'finishslide' && new_recording_status === 'init_recording') {
      this.handleStartRecording();
      this.recording_status = 'recording';
    } else if (new_recording_status === null) {
      // this is effectively a "reset"
      if (this.recorderSrvc) {
        if (this.show_video_stream) {
          this.recorderSrvc.softStopRecording();
          let stream = await this.recorderSrvc.getMediaStream();
          this.props.getMediaStreamCallback(stream);
        } else {
          this.recorderSrvc.cleanupThings();
          this.recorderSrvc = null;
          //if (this.show_video_stream) {
            this.props.getMediaStreamCallback(false); // so video goes away on screen
          //}
        }
      }
      
    //} else if (prev_recording_status === 'recording' && new_recording_status === 'nextslide') {
      // finish one slide then start recording the next slide
    //  this.handleNextSlide();
    } else if (prev_recording_status === 'recording' && new_recording_status === 'finishslide') {
      // finish one slide then stop recording
      this.handleFinishSlide();
    } else if (prev_recording_status === 'recording' && new_recording_status === 'recording_paused') {
      // pause recording
      this.handlePauseRecording();
    } else if (prev_recording_status === 'recording_paused' && new_recording_status === 'recording') {
      // unpause recording
      this.handleUnpauseRecording();
    //} else if (prev_recording_status === 'inactive' && new_recording_status === 'recording') {
      // this is a restart of entire thing
    //  this.recorderSrvc = null;
    //  this.handleStartRecording();
    } else if (new_recording_status === 'finished') {
      // finish entire presentation - only allowed from a paused state
      this.handleStopRecording();
    }
    
  }
  
  async handleStartRecording () {
    console.log("VideoRecorder handleStartRecording");
    if (!this.recorderSrvc) {
      console.log("VideoRecorder Creating new RecorderService");
      this.recorderSrvc = new RecorderService(this.onNewRecording);
      this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt));
    }

    let stream = await this.recorderSrvc.startRecording();
    if (!stream) {
      this.recorderSrvc.cleanupThings();
      this.recording_status = null;
      this.props.failureCallback();
    } else {
      console.log("VideoRecorder handleStartRecording STARTED");
      this.props.startCallback(stream);
    }
  }
  
  async handlePauseRecording() {
    console.log("VideoRecorder handlePauseRecording");

    if (this.recorderSrvc) {
      this.recorderSrvc.pauseRecording();
      //this.recorderSrvc.softStopRecording();
    }

    this.props.pauseCallback();
  }
  
  async handleUnpauseRecording() {
    console.log("VideoRecorder handleUnpauseRecording");

    if (this.recorderSrvc) {
      this.recorderSrvc.unpauseRecording();
      //this.recorderSrvc.softStopRecording();
    }

    this.props.unpauseCallback();

    /*
    if (!this.recorderSrvc) {
      console.log("VideoRecorder handleUnpauseRecording Creating new RecorderService");
      this.recorderSrvc = new RecorderService();
      this.recorderSrvc.em.addEventListener('recording', (evt) => this._onNewRecording(evt));
    }

    let stream = await this.recorderSrvc.startRecording();
    if (!stream) {
      this.recorderSrvc.cleanupThings();
      this.recording_status = null;
      this.props.failureCallback();
    } else {
      console.log("VideoRecorder handleUnpauseRecording STARTED");
      this.props.unpauseCallback(stream);
    }
    */

    /*
    await this.recorderSrvc.startRecording();
    console.log("VideoRecorder handleUnpauseRecording STARTED");
    
    this.props.unpauseCallback();
    */

  }
  
  async handleStopRecording() {
    console.log("VideoRecorder handleStopRecording");
    //if (!this.recorderSrvc) {
    //  this.recorderSrvc = new RecorderService();
    //}

    //let complete_mp3_blob = await this.recorderSrvc.concatSlideAudio(this.props.audioOutput_array);
    //let complete_mp3_blobUrl = window.URL.createObjectURL(complete_mp3_blob);
    
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
      //this.recorderSrvc.cleanupThings();
      //this.recorderSrvc = null;
    }
    
    //this.props.stopCallback(complete_mp3_blob,complete_mp3_blobUrl,'video/webm');
    
    //this.props.stopCallback();
  }
  
  /*
  async handleNextSlide() {
    console.log("VideoRecorder handleNextSlide");
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
    }
    this.props.nextSlideCallback();
  }
  */
  
  
  async handleFinishSlide() {
    console.log("VideoRecorder handleFinishSlide");
    if (this.recorderSrvc) {
      this.recorderSrvc.stopRecording();
    }
    this.props.finishSlideCallback();
  }
  

  onNewRecording (recording) {
    console.log("VideoRecorder onNewRecording",recording);
    // trying to handle unmount cleanup better
    if (this.recorderSrvc) {
      this.props.finishCallback(recording.blob,recording.blobUrl,recording.mimeType);
    } else {
      // no nothing...we are in cleanup mode
    }
  }

  _onNewRecording (evt) {
    console.log("VideoRecorder _onNewRecording",evt);
    // trying to handle unmount cleanup better
    if (this.recorderSrvc) {
      this.props.finishCallback(evt.detail.recording.blob,evt.detail.recording.blobUrl,evt.detail.recording.mimeType);
    } else {
      // no nothing...we are in cleanup mode
    }
  }
  
  render() {
    return "";
  }

}


export default VideoRecorder;
